import './index.scss'
import MenubarLanding from '../MenubarLanding'
import { Button } from 'primereact/button'; 
import { useLocation } from 'react-router-dom';
import React, { useState, useEffect } from "react";

// Solo escanea las carpetas de año (2017, 2018, ...); la carpeta /common
// queda excluida del escaneo automático porque sus archivos se referencian
// manualmente abajo en `sharedReports`, para poder mostrarlos en varios años
// sin duplicar el PDF físicamente.
const pdfFiles = require.context('../../assets/reportsPDF', true, /^\.\/\d{4}\/.*\.pdf$/);

// Informes que antes estaban repetidos (mismo PDF) en varias carpetas de año.
// Ahora el archivo vive una sola vez en /common y aquí se indica en qué
// año(s) debe seguir apareciendo, conservando el nombre visible original.
const commonFiles = require.context('../../assets/reportsPDF/common', false, /\.pdf$/);
const sharedReports = {
    '2017': [
        { file: './Acta de Constitucion y Estatutos Waima.pdf', name: 'Acta de Constitución y Estatutos Waima' },
    ],
    '2018': [
        { file: './Estatutos Originales Waima.pdf', name: 'ESTATUTOS' },
    ],
    '2020': [
        { file: './Acta de Constitucion y Estatutos Waima.pdf', name: 'ACTA DE CONSTITUCIÓN Y ESTATUTOS' },
    ],
    '2021': [
        { file: './Estatutos Originales Waima.pdf', name: 'ESTATUTOS ORIGINALES WAIMA' },
        { file: './Certificado de Existencia y Representacion Legal.pdf', name: 'Certificado de existencia y representacion legal' },
        { file: './Estados Financieros Año 2021.pdf', name: 'ESTADOS FINANCIEROS AÑO 2021' },
        { file: './Informe de Gestion 2021.pdf', name: 'INFORME DE GESTIÓN 2021' },
    ],
    '2022': [
        { file: './Estatutos Originales Waima.pdf', name: 'ESTATUTOS ORIGINALES WAIMA' },
        { file: './Certificado de Existencia y Representacion Legal.pdf', name: 'CERTIFICADO DE EXISTENCIA Y REPRESENTACIÓN LEGAL' },
        { file: './Estados Financieros Año 2021.pdf', name: 'ESTADOS FINANCIEROS AÑO 2021' },
        { file: './Informe de Gestion 2021.pdf', name: 'INFORME DE GESTIÓN 2021' },
    ],
    '2023': [
        { file: './Estatutos Originales Waima.pdf', name: 'ESTATUTOS ORIGINALES WAIMA' },
    ],
    '2024': [
        { file: './Estatutos Originales Waima.pdf', name: 'ESTATUTOS ORIGINALES WAIMA' },
    ],
    '2025': [
        { file: './Estatutos Originales Waima.pdf', name: 'ESTATUTOS ORIGINALES WAIMA' },
    ],
};

const Reports = () => {

    const [language, setLanguage] = useState(localStorage.getItem("lang") || "es");
        
          useEffect(() => {
                const handleLanguageChange = () => {
                    setLanguage(localStorage.getItem("lang") || "es");
                };
        
                window.addEventListener("languageChange", handleLanguageChange);
        
                return () => window.removeEventListener("languageChange", handleLanguageChange);
            }, []);
    
    const pdfMap = {};

    const location = useLocation();
    const year = location.state?.year;

    const valuesColors = [
        "#8c458a", // Purple
        "#D9991E", // Orange
        "#9DAD2A", // Green
        "#c3b8d8", // Blue
        "#E94B3C", // Red
        "#FFD700", // Gold
        "#40E0D0", // Turquoise
        "#FF69B4", // Pink
        "#8B4513"  // Brown
    ];
    
    pdfFiles.keys().forEach((filePath) => {
        const fullPath = filePath.replace('./', ''); 
        const [yearFolder, fileName] = fullPath.split('/');

        if (!pdfMap[yearFolder]) pdfMap[yearFolder] = []; 
        pdfMap[yearFolder].push({
            name: fileName.replace('.pdf', ''),
            url: pdfFiles(filePath)
        });
    });

    Object.entries(sharedReports).forEach(([sharedYear, reports]) => {
        if (!pdfMap[sharedYear]) pdfMap[sharedYear] = [];
        reports.forEach(({ file, name }) => {
            pdfMap[sharedYear].push({ name, url: commonFiles(file) });
        });
    });

    const selectedReports = pdfMap[year] || [];

    return (
        <main>
            <MenubarLanding />
            <div className='reports-container-primary'>
                <div className='reports-container-secondary'>
                    <h1>{language === "en" ? "REPORTS " : "INFORMES "} {year}</h1>

                    <div className='reports-content-grid'>
                        {selectedReports.map((report, index) => (
                            <Button 
                                className='reports-btn' 
                                key={index} 
                                style={{ backgroundColor: valuesColors[index % valuesColors.length] }}
                                onClick={() => window.open(report.url, '_blank')}
                            >
                                <h2>{report.name}</h2>
                            </Button>
                        ))}
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Reports;
